var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYatra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 441.77 189.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#ea2330;}.cls-3{opacity:0.7;}.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{mix-blend-mode:multiply;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 352.06,
    y1: 362.84,
    x2: 362.37,
    y2: 304.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#dfdfe0",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#88898a",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#666769",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 593.16,
    y1: 362.84,
    x2: 603.5,
    y2: 304.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#dfdfe0",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#88898a",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666769",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 426.99,
    y1: 262.24,
    x2: 489.72,
    y2: 282.62,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 234.23,
    y1: 104.55,
    x2: 234.23,
    y2: 51.89,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 204.57,
    y1: 280.65,
    x2: 236.03,
    y2: 333.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f0f0f1",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8d8d8f",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666769",
    stopOpacity: 0.7
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "YATRA FINAL RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy",
    "data-name": "Layer 1 copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M446.14,339.26c4.47-.78,8.89,3.13,9.87,8.77s-1.84,10.9-6.31,11.68l-.13,0a81,81,0,0,1-14.22,1.38c-9.95,0-18-2.39-24.2-7.19-8-6.14-12.22-15.81-12.22-27.94V213.79c0-4.53,4.65-8.21,10.38-8.21s10.38,3.68,10.38,8.21V326c0,5.52,1.38,9.37,4.11,11.47,2.46,1.89,8.44,4.3,22.16,1.83Z",
    transform: "translate(-175.08 -205.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.3,351.31c-3.76,0-7.32-5.52-9.16-9.1-9.65-18.74-17-33.7-22.87-45.72-12-24.55-18.51-36.23-23.91-40.39s-6.5-9.57-3.92-14.35a10.12,10.12,0,0,1,13.89-3.85c11.56,6.57,17.58,18.85,32.58,49.47,5.82,11.88,13.06,26.66,22.55,45.09,2.35,4.56,4,13.75-.11,16.79Z",
    transform: "translate(-175.08 -205.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M479.36,306.82A49.4,49.4,0,0,0,430,257.47l-43.63,0c-4.54,0-8.21-4.65-8.21-10.38s3.67-10.38,8.21-10.38l43.63,0a70.1,70.1,0,0,1,70.1,70.1V353c0,4.53-4.65,8.21-10.38,8.21s-10.38-3.68-10.38-8.21Z",
    transform: "translate(-175.08 -205.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M354.9,319.89V321c0,11.83-9.6,19.49-24.63,19.49s-24.73-7.64-24.73-19.47,9.71-19.51,24.73-19.51h.91c15.66,0,42.71,7.21,44.57,7.82V289.59c-10-3.52-26-8.82-44.57-8.82h-.91c-27.82,0-45.49,18.05-45.49,40.26s17.67,40.21,45.49,40.21,45.49-18,45.49-40.21v-1l-.09-43.08c0-22.21-21.45-40.21-45.4-40.21l-4-.06c-31.64,0-56.42,8.56-74.52,50.34-1.48,3.41-2.88,6.8-4.24,10.17l-.2.48c-4.33,10.69-6.87,18.55-13.12,33-11.68,27-22.16,42.77-38.11,43.69-8.65.5-10.77,6.26-9.69,12s4.66,9.22,9.69,9.22c26,0,42.25-23.92,57.82-58l.19-.44c2.37-5.54,4.64-11.3,7-17.27,3.1-8,6.31-16.32,9.87-24.54,13.83-31.92,29.49-37.82,55.36-37.82h4c11.09,0,24.63,7.64,24.63,19.45v42.81",
    transform: "translate(-175.08 -205.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M596.11,319.89V321c0,11.83-9.72,19.49-24.75,19.49s-24.73-7.64-24.73-19.47,9.71-19.51,24.73-19.51h.92c15.66,0,42.71,7.21,44.58,7.82V289.59c-10-3.52-26.05-8.82-44.58-8.82h-.92c-27.82,0-45.49,18.05-45.49,40.26s17.67,40.21,45.49,40.21,45.49-18,45.49-40.21v-1l-.09-43.08c0-22.21-21.45-40.14-45.4-40.14,0,0-7.46-.07-9-.07-51.13,0-83,33.34-83,79.43h20.76c0-34.58,22.61-58.68,62.21-58.68,1.83,0,7.6.08,7.6.08,14.9,0,26.18,7.55,26.18,19.37v43Z",
    transform: "translate(-175.08 -205.58)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M354.9,304.45V321c0,9.26-5.9,15.94-15.67,18.42v21.14c22.59-3.43,36.53-19.82,36.53-39.54v-1l0-10.66C373.35,308.73,360.81,305.91,354.9,304.45Z",
    transform: "translate(-175.08 -205.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M596.11,304.45V321c0,9.26-6,16-15.78,18.45v21.12c22.59-3.43,36.53-19.82,36.53-39.54v-1l0-10.66C614.44,308.73,602,305.91,596.11,304.45Z",
    transform: "translate(-175.08 -205.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M435.22,236.93v20.82a49.41,49.41,0,0,1,44.14,49.07v2.54h.26a80.29,80.29,0,0,1,11.48-36.93A70.1,70.1,0,0,0,435.22,236.93Z",
    transform: "translate(-175.08 -205.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 223.85,
    y: 51.89,
    width: 20.77,
    height: 52.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M204.27,296.5c5.89,12,13.22,27,22.87,45.72.27.53.58,1.1.93,1.69,2-4.06,4.07-8.49,6.14-13.28,1.82-4.19,3.31-7.81,4.64-11.12-6.36-12.57-11.55-23.18-15.94-32.13Z",
    transform: "translate(-175.08 -205.58)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYatra);
export default __webpack_public_path__ + "static/media/YATRA.939ff22432e7be642049020f5f806ccf.svg";
export { ForwardRef as ReactComponent };